/**
 * Test IDs for QA automation.
 */
export const testIds = {
  automationConfigPanelFrequencyMinutesToggle: "automation-config-panel-frequency-minutes-toggle",
  automationConfigPanelFrequencyMinutesField: "automation-config-panel-frequency-minutes-field",
  automationConfigPanelForecastQuantity: "automation-config-panel-forecast-quantity",
  automationConfigPanelSaveConfiguration: "automation-config-panel-save-configuration",
  automationConfigPanelTriggerManualRun: "automation-config-panel-trigger-manual-run",
  automationConfigPanelViewExecutionHistory: "automation-config-panel-view-execution-history",
  automationConfigPanelClose: "automation-config-panel-close",
} as const;
